import { get } from "lodash";
import log from "loglevel";
import { ErrorType } from "types";
import * as t from "./types";

export const getAnalysisReducerResponse = (
  state: any,
  responseType: string
): t.Analysis => {
  log.info("Getting Analysis from Store...");
  const value = get(state, `analysis.response.${responseType}`);
  return value;
};

export const getAnalysisErrorReducerResponse = (state: any): ErrorType => {
  log.info("Getting Analysis Error from Store...");
  const value = get(state, `analysis.response.error`);
  return value;
};

export const getAnalysesReducerResponse = (
  state: any,
  responseType: string
): t.Analysis[] => {
  log.info("Getting Analyses from Store...");
  const value = get(state, `analyses.response.${responseType}`);
  return value;
};

export const getAnalysisTeamsReducerResponse = (
  state: any,
  responseType: string
): t.AnalysisTeam[] => {
  log.info("Getting AnalysisTeams from Store...");
  const value = get(state, `analysisTeams.response.${responseType}`);
  return value;
};
